export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8447.0cbd6b04.jpg";